'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var Checkbox_module = require('./Checkbox.module.css.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Check = require('./Check.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Checkbox = _ref => {
  let {
    children,
    id,
    name = '',
    value,
    onChange = () => undefined,
    checked = false,
    boxStyle = {},
    containerStyle = {},
    labelBoxCellStyle = {},
    labelTextCellStyle = {},
    checkStyle = {}
  } = _ref;
  const {
    iconsPrimaryNone,
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const checkContainerClasses = clsx.clsx(Checkbox_module["default"].checkContainer, checked && Checkbox_module["default"].checkContainerChecked);
  const checkbox = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("input", {
    className: Checkbox_module["default"].visuallyHiddenInput,
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    type: "checkbox",
    checked: checked
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: checkContainerClasses,
    style: {
      ...iconsPrimaryNone,
      ...boxStyle,
      borderColor: iconsPrimaryNone === null || iconsPrimaryNone === void 0 ? void 0 : iconsPrimaryNone.color,
      backgroundColor: checked ? iconsPrimaryNone === null || iconsPrimaryNone === void 0 ? void 0 : iconsPrimaryNone.color : 'transparent'
    }
  }, checked ? /*#__PURE__*/React__default["default"].createElement(Check["default"], {
    checkStyle: checkStyle
  }) : null));
  if (!children) return /*#__PURE__*/React__default["default"].createElement("div", {
    style: containerStyle
  }, checkbox);
  return /*#__PURE__*/React__default["default"].createElement("label", {
    className: Checkbox_module["default"].label,
    htmlFor: id,
    style: containerStyle
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Checkbox_module["default"].labelTable
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Checkbox_module["default"].labelBoxCell,
    style: labelBoxCellStyle
  }, checkbox), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Checkbox_module["default"].labelTextCell,
    style: {
      ...labelTextCellStyle,
      ...bodytextDefaultNone
    }
  }, children)));
};
var Checkbox$1 = nthHookTheme.withThemeProvider(Checkbox, {
  themeTokens: ['iconsPrimaryNone', 'bodytextDefaultNone']
});

exports["default"] = Checkbox$1;
